var _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnprocessorders(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#fff}.cls-5{fill:none;stroke:#fff;stroke-linecap:round}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16293",
    "data-name": "Group 16293",
    transform: "translate(-441 -178)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5798",
    "data-name": "Rectangle 5798",
    className: "cls-1",
    transform: "translate(441 178)",
    d: "M0 0h60v60H0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8793",
    "data-name": "Group 8793",
    transform: "translate(451.673 191.282)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_633",
    "data-name": "Ellipse 633",
    cx: 26,
    cy: 26,
    r: 26,
    transform: "translate(-6.673 -9.282)",
    style: {
      fill: "rgba(227,221,255,.5)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16302",
    "data-name": "Group 16302",
    transform: "translate(-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g20571",
    transform: "translate(4.472 4.601)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8081-77",
    d: "M3.964 280.6h17.655a2.637 2.637 0 0 1 2.7 2.577V300.9a2.637 2.637 0 0 1-2.7 2.577H3.964a2.637 2.637 0 0 1-2.7-2.577v-17.728a2.637 2.637 0 0 1 2.7-2.572z",
    transform: "translate(-1.26 -280.596)",
    style: {
      fill: "#3a0e96"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path8083-26",
    className: "cls-1",
    d: "M6.883 280.6v6.84a1.208 1.208 0 0 0 1.211 1.21h3.348a1.208 1.208 0 0 0 1.211-1.21v-6.84z",
    transform: "translate(1.762 -280.595)"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_626",
    "data-name": "Ellipse 626",
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    transform: "translate(19.327 14.718)",
    style: {
      fill: "#957eff"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Line_277",
    "data-name": "Line 277",
    className: "cls-5",
    transform: "translate(25.099 20.665)",
    d: "m0 0 4.797 4.317"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Line_278",
    "data-name": "Line 278",
    className: "cls-5",
    transform: "translate(25.099 20.665)",
    d: "M4.797 0 0 4.317"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnprocessorders);
export default __webpack_public_path__ + "static/media/unprocessorders.449a7737a67ce9e76dfb122e92b2b033.svg";
export { ForwardRef as ReactComponent };